import React from "react";
import { Box, Typography, Paper, Chip, Stack } from "@mui/material";
import { WorkflowDefinition } from "../api/workflowTypes";

interface WorkflowDefinitionHeaderProps {
    workflowDefinition: WorkflowDefinition;
}

const WorkflowDefinitionHeader: React.FC<WorkflowDefinitionHeaderProps> = ({ workflowDefinition }) => {
    const { name, objectType, objectSubType, version } = workflowDefinition;

    return (
        <Paper
            elevation={1}
            sx={{
                p: 2,
                borderRadius: 1,
                backgroundColor: "#f5f5f5", // Delikatne szare tło
                position: "relative"
            }}
        >
            <Box>
                <Stack direction="row" spacing={1} alignItems="center">

                    <Typography variant="h5" fontWeight="bold">
                        Workflow definiion | {name}
                    </Typography>
                </Stack>

                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                    <span style={{ fontWeight: "bold" }}>Version:</span> {version} |{" "}
                    <span style={{ fontWeight: "bold" }}>Object type:</span> {objectType} |{" "}
                    <span style={{ fontWeight: "bold" }}>Document:</span> {objectSubType} {" "}
                </Typography>
            </Box>
        </Paper>
    );
};

export default WorkflowDefinitionHeader;
